function hasChildren({ children }={}) {
    return children && children.length;
}

function updateHook(elm, directive, vnode) {
    let { componentOptions } = vnode;
    if(!hasChildren(componentOptions) && !hasChildren(vnode)) {
        elm.style.display = 'none';
        elm.classList.add('hide-if-empty');
    }
    else {
        elm.style.display = '';
        elm.classList.remove('hide-if-empty');
    }
}

export default {
    bind: updateHook,
    componentUpdated: updateHook
}